import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AuthService} from "../../api/services/auth.service";
import {MessageService} from "../../api/services/message.service";
import {Router} from "@angular/router";
import {base} from "../../api/api-config";
import {Subscription} from "rxjs";
import {User} from "../../api/models/user";
import {Survey} from "../../api/models/survey";
import {WaButtonDirective} from "angular-awesome";

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrl: './welcome.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [WaButtonDirective]
})
export class WelcomeComponent {

   private userSub: Subscription;

  user: User | null = null;
  survey: Survey | null = null;

  constructor(private router: Router,
              private authService: AuthService,
              private msgService: MessageService) {

    this.userSub = this.authService.loggedInUser$.subscribe({
      next: user => {
        this.user = user;
        this.authService.refresh(false);
      },
      error: err => {
        this.msgService.log(err.message);
        this.msgService.showSimple('Could not fetch logged in user.');
      }
    });
  }

  shibboleth_login(): void {
    if (!!this.user) return;
    window.location.href = `${base}/shib-login`;
  }

  guest_login(): void {
    if (!!this.user) {
      console.log("User logged in!")
      return;
    }
    this.router.navigateByUrl('login');
  }
}
